import React from 'react';
import './Offering.css';
import { Helmet } from 'react-helmet-async';




const Beratung = () => (
    <>
        <Helmet>
            <title>Ernährungsberatung</title>
            <meta name="description" content='Ernährungsberatung für eine gesündere Lebensweise. Erfahren Sie 
            mehr über Lebensmittelauswahl, Essverhalten und Reduzierung von Risikofaktoren. Die meisten Krankenkassen 
            bezuschussen bis zu 3 Beratungstermine im Rahmen der Prävention (§ 20 SGB V). Zielgerichtete Unterstützung bei Figuroptimierung, Menopause, 
            Schwangerschaft, Raucherentwöhnung, Ernährung und Sport, Schichtarbeit, Ernährung für Best-Ager' />
        </Helmet>
        <div className='Beratung'>
            <div className="BeratungWrapper">
                <div className='entrycontent'>

                    <h2 className='header'>Ernährungsberatung</h2>

                    <p className='text'>Eine Ernährungsberatung wendet sich an alle Menschen, die sich mit dem Thema Ernährung intensiver auseinandersetzen möchten und Informationen zur Lebensmittelauswahl, dem Essverhalten und der Reduzierung von Risikofaktoren wünschen.</p>
                    <p className='text'>Im Rahmen der Vorbeugung ( Prävention § 20 SGB V ) bezuschussen die meisten Krankenkassen bis zu 3 Beratungstermine oder mehr.</p>
                    <br />
                    <p className='text'>Eine Beratung ist zielführend bei:</p>
                    <ul>
                        <li className='listentry'>einem Wusch nach Figuroptimierung</li>
                        <li className='listentry'>beginnender Menopause</li>
                        <li className='listentry'>Schwangerschaft und Stillzeit</li>
                        <li className='listentry'>Raucherentwöhnung</li>
                        <li className='listentry'>Fragen zu Ernährung und Sport</li>
                        <li className='listentry'>Fragen zu Ernährung und Schichtarbeit</li>
                        <li className='listentry'>Ernährung für Best-Ager</li>
                    </ul>
                </div>

            </div>

        </div>

    </>


)

export default Beratung;